import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';

import { useTargetAccumulatorSelector } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { getTargetAccumulatorMarketData } from '@/store/targetAccumulator/selectors.ts';

const Volatility = () => {
  const { formatNumber } = useIntl();
  const marketData = useTargetAccumulatorSelector((targetAccumulator) =>
    getTargetAccumulatorMarketData(targetAccumulator),
  );
  const isExpired = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator.properties.rfs.status === 'EXPIRED',
  );

  return (
    <div className={clsx('form-group form-group-sm d-flex my-1', { expired: isExpired })}>
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="option.fields.volatility" />
      </div>
      <span className="d-flex flex-column px-1 fs-6" style={{ width: '64%' }} data-e2e="volatility">
        {marketData?.volatility &&
          formatNumber(marketData?.volatility, { maximumFractionDigits: 3, minimumFractionDigits: 3 })}
      </span>
    </div>
  );
};

export default Volatility;
